module.exports = {
  messages: {
    CN: {
      "holidayset.noWeekends": "周末是休息日",
      "holidayset.yesWeekends": "周末是工作日",
      "holidayset.previousyear": "上一年",
      "holidayset.nextyear": "下一年",
      "holidayset.savesure": "确定要进行保存吗？"
    },
    JP: {
      "holidayset.noWeekends": "週末は休日",
      "holidayset.yesWeekends": "週末は営業日",
      "holidayset.previousyear": "前年",
      "holidayset.nextyear": "次年",
      "holidayset.savesure": "保存してもよろしいですか？"
    }
  }
};